export const MAIN_CLASS_NAME = 'dependencies-modal';
export const TITLE_CLASS_NAME = `${MAIN_CLASS_NAME}__title`;
export const SECTION_CLASS_NAME = `${MAIN_CLASS_NAME}__section`;
export const SECTION_HEADER_CLASS_NAME = `${SECTION_CLASS_NAME}__header`;
export const GROUP_CLASS_NAME = `${MAIN_CLASS_NAME}__group`;
export const GROUP_TITLE_CLASS_NAME = `${GROUP_CLASS_NAME}__title`;
export const SUB_GROUP_CLASS_NAME = `${GROUP_CLASS_NAME}__sub`;
export const SUB_GROUP_TITLE_CLASS_NAME = `${SUB_GROUP_CLASS_NAME}__title`;
export const ROW_CLASS_NAME = `${MAIN_CLASS_NAME}__row`;
export const ROW_ITEM_CLASS_NAME = `${ROW_CLASS_NAME}__item`;
export const ROW_ITEM_TOOLTIP_CLASS_NAME = `${ROW_ITEM_CLASS_NAME}__tooltip`;
export const ROW_ITEM_PATH_CLASS_NAME = `${ROW_ITEM_CLASS_NAME}__path`;
export const ROW_ITEM_OBJECT_CLASS_NAME = `${ROW_ITEM_CLASS_NAME}__object`;
export const ROW_ICON_CLASS_NAME = `${ROW_CLASS_NAME}__icon`;
export const EXTRA_CLASS_NAME = `${MAIN_CLASS_NAME}__extra`;
export const EXTRA_CHECKBOX_CLASS_NAME = `${EXTRA_CLASS_NAME}__checkbox`;

export const SELECT_LABEL_CLASS_NAME = `${MAIN_CLASS_NAME}__select-label`;
export const UNSELECTED_ALERT_CLASS_NAME = `${MAIN_CLASS_NAME}__unselected-alert`;
export const UNSELECTED_ALERT_BUTTON_CLASS_NAME = `${UNSELECTED_ALERT_CLASS_NAME}__button`;

export const INGEST_SOURCES_EXTRA_KEY = 'ingest-sources';
export const DELETE_SOURCES_EXTRA_KEY = 'delete-sources';
